"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportBundle = void 0;
const lodash_pick_1 = __importDefault(require("lodash.pick"));
const constants_1 = require("./constants");
const emitter_1 = require("./emitter");
const http_1 = require("./http");
const sleep = (duration) => new Promise(resolve => setTimeout(resolve, duration));
async function pollReport(options) {
    var _a, _b;
    const projectName = (_b = (_a = options.report) === null || _a === void 0 ? void 0 : _a.projectName) === null || _b === void 0 ? void 0 : _b.trim();
    const projectNameMaxLength = 64;
    if (!projectName || projectName.length === 0) {
        throw new Error('"project-name" must be provided for "report"');
    }
    if (projectName.length > projectNameMaxLength) {
        throw new Error(`"project-name" must not exceed ${projectNameMaxLength} characters`);
    }
    if (/[^A-Za-z0-9-_/]/g.test(projectName)) {
        throw new Error(`"project-name" must not contain spaces or special characters except [/-_]`);
    }
    emitter_1.emitter.analyseProgress({
        status: http_1.AnalysisStatus.waiting,
        progress: 0,
    });
    // First init the report
    const initResponse = await (0, http_1.initReport)(options);
    if (initResponse.type === 'error') {
        return initResponse;
    }
    const { reportId } = initResponse.value;
    let apiResponse;
    let response;
    // eslint-disable-next-line no-constant-condition
    while (true) {
        // eslint-disable-next-line no-await-in-loop
        apiResponse = await (0, http_1.getReport)({
            ...(0, lodash_pick_1.default)(options, ['baseURL', 'sessionToken', 'source', 'requestId', 'org']),
            reportId,
        });
        if (apiResponse.type === 'error') {
            return apiResponse;
        }
        response = apiResponse.value;
        if (response.status === http_1.AnalysisStatus.waiting ||
            response.status === http_1.AnalysisStatus.fetching ||
            response.status === http_1.AnalysisStatus.analyzing ||
            response.status === http_1.AnalysisStatus.done) {
            // Report progress of fetching
            emitter_1.emitter.analyseProgress(response);
        }
        else if (response.status === http_1.AnalysisStatus.complete) {
            // Return data of analysis
            return apiResponse;
            // deepcode ignore DuplicateIfBody: false positive it seems that interface is not taken into account
        }
        else if (response.status === http_1.AnalysisStatus.failed) {
            // Report failure of analysing
            return apiResponse;
        }
        // eslint-disable-next-line no-await-in-loop
        await sleep(constants_1.POLLING_INTERVAL);
    }
}
async function reportBundle(options) {
    // Call remote bundle for analysis results and emit intermediate progress
    const response = await pollReport(options);
    if (response.type === 'error') {
        throw response.error;
    }
    else if (response.value.status === http_1.AnalysisStatus.failed) {
        throw new Error('Analysis has failed');
    }
    return response.value;
}
exports.reportBundle = reportBundle;
//# sourceMappingURL=report.js.map